/* Dr. Bali - Motion layer. Calm, quiet, restrained. */
(function () {
  'use strict';
  if (window.__drbaliMotion) return;
  window.__drbaliMotion = true;

  var root = document.documentElement;

  // Debug switch: add ?motion=off to the address to see the page without any motion.
  if (window.location.search.indexOf('motion=off') !== -1) {
    root.classList.add('dm-off');
    return;
  }
  if (window.Shopify && window.Shopify.designMode) return;

  function mq(query) {
    return !!(window.matchMedia && window.matchMedia(query).matches);
  }

  var reduce = mq('(prefers-reduced-motion: reduce)');
  try {
    window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', function (event) {
      if (event.matches) root.classList.add('dm-off', 'dm-tilt-off');
    });
  } catch (e) { /* older browsers */ }
  var fine = mq('(hover: hover) and (pointer: fine)') && mq('(min-width: 990px)');
  var small = mq('(max-width: 749px)');

  var STAGE = '.drbali-shoplook__stage';

  // [selector, kind]. Only these are ever touched. Everything else stays static on purpose.
  // Each section gets its own gesture; finder, footer and the commerce UI stay still.
  var REVEALS = [
    // Headings stay still on purpose: only images and the brand sentence move.
    ['.drbali-statement__text, .drbali-statement__by', 'quote'],
    ['.drbali-featured__item', 'card'],
    ['.drbali-category-card', 'maskcard'],
    ['.drbali-editorial__media-wrap', 'wipe'],
    [STAGE, 'frame'],
    ['.dm-look-index li', 'card']
  ];

  // Collection pages: product cards below the first screen arrive softly.
  var COLLECTION_REVEALS = [
    ['.drbali-card', 'card']
  ];

  var TILT_TARGETS = '.drbali-product-card__media, .drbali-card__media';

  function pad(value) {
    var text = String(value);
    return text.length < 2 ? '0' + text : text;
  }

  // Builds a quiet numbered index under the photo and keeps it in sync with the dots.
  function buildLookIndex(look) {
    var stage = look.querySelector(STAGE);
    var hotspots = Array.prototype.slice.call(look.querySelectorAll('[data-drbali-hotspot]'));
    if (!stage || hotspots.length < 2 || look.querySelector('.dm-look-index')) return;

    var list = document.createElement('ol');
    list.className = 'dm-look-index';
    list.setAttribute('aria-label', 'Görseldeki ürünler');

    hotspots.forEach(function (hotspot, index) {
      var toggle = hotspot.querySelector('[data-drbali-hotspot-toggle]');
      var title = hotspot.querySelector('.drbali-shoplook__card-title');
      if (!toggle || !title) return;

      var price = hotspot.querySelector('.drbali-shoplook__card-price span');
      var marker = hotspot.querySelector('.drbali-shoplook__marker-index');
      hotspot.style.setProperty('--dm-i', String(index));

      var item = document.createElement('li');
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'dm-look-index__item';

      var number = document.createElement('span');
      number.className = 'dm-look-index__n';
      number.textContent = pad(marker ? marker.textContent.trim() : index + 1);

      var name = document.createElement('span');
      name.className = 'dm-look-index__t';
      name.textContent = title.textContent.trim();

      var cost = document.createElement('span');
      cost.className = 'dm-look-index__p';
      cost.textContent = price ? price.textContent.trim() : '';

      button.appendChild(number);
      button.appendChild(name);
      button.appendChild(cost);
      item.appendChild(button);
      list.appendChild(item);

      var on = function () {
        stage.classList.add('dm-look-focus');
        hotspot.classList.add('is-dm-focus');
        button.classList.add('is-active');
      };
      var off = function () {
        stage.classList.remove('dm-look-focus');
        hotspot.classList.remove('is-dm-focus');
        button.classList.remove('is-active');
      };

      button.addEventListener('mouseenter', on);
      button.addEventListener('mouseleave', off);
      button.addEventListener('focus', on);
      button.addEventListener('blur', off);
      toggle.addEventListener('mouseenter', on);
      toggle.addEventListener('mouseleave', off);

      // The section closes cards on any outside click, so keep this click to ourselves.
      button.addEventListener('click', function (event) {
        event.stopPropagation();
        toggle.click();
      });
    });

    if (list.children.length) stage.insertAdjacentElement('afterend', list);
  }

  // Soft reveal for the homepage sections that are meant to move.
  function initReveals(main, list) {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var marked = [];
    var textCount = new Map();
    var cardCount = new Map();

    list.forEach(function (entry) {
      Array.prototype.forEach.call(main.querySelectorAll(entry[0]), function (el) {
        if (el.hasAttribute('data-dm') || el.hasAttribute('data-dm-skip')) return;

        // Anything already visible on load stays still, so nothing flashes.
        var rect = el.getBoundingClientRect();
        if (rect.top < vh * 0.92 && rect.bottom > 0) {
          el.setAttribute('data-dm-skip', '');
          return;
        }

        var kind = entry[1];
        if (reduce) kind = 'soft';
        else if (small && kind === 'maskcard') kind = 'card';

        var delay = 0;
        if (entry[1] === 'text' || entry[1] === 'quote') {
          var section = el.closest('.shopify-section') || main;
          var n = textCount.get(section) || 0;
          textCount.set(section, n + 1);
          delay = Math.min(n, 3) * (entry[1] === 'quote' ? 160 : 80);
        } else if (entry[1] === 'card' || entry[1] === 'maskcard') {
          var parent = el.parentElement;
          var i = cardCount.get(parent) || 0;
          cardCount.set(parent, i + 1);
          delay = Math.min(i, 3) * 110;
        }

        el.setAttribute('data-dm', kind);
        el.style.setProperty('--dm-delay', delay + 'ms');
        marked.push(el);
      });
    });

    // A photo that is already on screen shows its dots straight away.
    Array.prototype.forEach.call(main.querySelectorAll('.drbali-shoplook'), function (look) {
      var stage = look.querySelector(STAGE);
      if (!stage || !stage.hasAttribute('data-dm')) look.classList.add('dm-look-in');
    });

    if (!marked.length) return;

    var io;
    var pending = marked.slice();

    function reveal(node) {
      if (!node.hasAttribute('data-dm') || node.classList.contains('dm-in')) return;
      var kind = node.getAttribute('data-dm');
      if (io) io.unobserve(node);
      node.classList.add('dm-in');

      // Once the photo has faded in, the dots start to appear.
      if (node.matches(STAGE)) {
        var look = node.closest('.drbali-shoplook');
        if (look) window.setTimeout(function () { look.classList.add('dm-look-in'); }, 900);
      }

      // After the animation, hand the element back to the theme untouched.
      var base = 1600;
      if (kind === 'card' || kind === 'quote') base = 2200;
      else if (kind === 'maskcard' || kind === 'frame' || kind === 'wipe') base = 3200;
      else if (kind === 'soft') base = 1000;

      var wait = (parseFloat(node.style.getPropertyValue('--dm-delay')) || 0) + base;
      window.setTimeout(function () {
        node.removeAttribute('data-dm');
        node.classList.remove('dm-in');
        node.style.removeProperty('--dm-delay');
      }, wait);
    }

    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) reveal(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    // Safety net: anything on screen that the observer missed is revealed here,
    // so content can never stay hidden.
    var sweepTimer = null;
    var sweepQueued = false;

    function sweep() {
      var h = window.innerHeight || document.documentElement.clientHeight;
      for (var i = pending.length - 1; i >= 0; i--) {
        var node = pending[i];
        if (!node.hasAttribute('data-dm') || node.classList.contains('dm-in')) {
          pending.splice(i, 1);
          continue;
        }
        var r = node.getBoundingClientRect();
        if (r.top < h * 0.9 && r.bottom > 0) {
          reveal(node);
          pending.splice(i, 1);
        }
      }
      if (!pending.length) {
        window.removeEventListener('scroll', onSweepScroll);
        window.removeEventListener('resize', onSweepScroll);
        if (sweepTimer) window.clearInterval(sweepTimer);
      }
    }

    function onSweepScroll() {
      if (sweepQueued) return;
      sweepQueued = true;
      window.requestAnimationFrame(function () {
        sweepQueued = false;
        sweep();
      });
    }

    root.classList.add('dm-ready');
    marked.forEach(function (node) { io.observe(node); });
    window.addEventListener('scroll', onSweepScroll, { passive: true });
    window.addEventListener('resize', onSweepScroll);
    sweepTimer = window.setInterval(sweep, 800);
    sweep();
  }

  // Product cards (desktop, mouse): the frame turns a couple of degrees, a faint light
  // crosses the surface and the shadow leans away. Every value is smoothed on every
  // frame so it trails the pointer softly and eases back to rest. If the page ever
  // drops below a comfortable frame rate, the whole effect switches itself off.
  function initTilt() {
    if (reduce || !fine || !window.requestAnimationFrame) return;

    var NEUTRAL = { rx: 0, ry: 0, gx: 50, gy: 30, sx: 0, sy: 18, sa: 0, sc: 1, tz: 0 };
    var states = new Map();
    var running = false;
    var last = 0;
    var slow = 0;
    var disabled = false;

    function copy(source) {
      return { rx: source.rx, ry: source.ry, gx: source.gx, gy: source.gy, sx: source.sx, sy: source.sy, sa: source.sa, sc: source.sc, tz: source.tz };
    }

    function apply(media, c) {
      media.style.setProperty('--dm-rx', c.rx.toFixed(3) + 'deg');
      media.style.setProperty('--dm-ry', c.ry.toFixed(3) + 'deg');
      media.style.setProperty('--dm-gx', c.gx.toFixed(2) + '%');
      media.style.setProperty('--dm-gy', c.gy.toFixed(2) + '%');
      media.style.setProperty('--dm-sx', c.sx.toFixed(2) + 'px');
      media.style.setProperty('--dm-sy', c.sy.toFixed(2) + 'px');
      media.style.setProperty('--dm-sa', c.sa.toFixed(4));
      media.style.setProperty('--dm-sc', c.sc.toFixed(4));
      media.style.setProperty('--dm-tz', c.tz.toFixed(2) + 'px');
    }

    function clear(media) {
      ['--dm-rx', '--dm-ry', '--dm-gx', '--dm-gy', '--dm-sx', '--dm-sy', '--dm-sa', '--dm-sc', '--dm-tz'].forEach(function (name) {
        media.style.removeProperty(name);
      });
      media.classList.remove('dm-tilting');
    }

    function release(state) {
      state.active = false;
      state.target = copy(NEUTRAL);
    }

    function shutDown() {
      disabled = true;
      states.forEach(function (state, media) { clear(media); });
      states.clear();
      running = false;
      root.classList.add('dm-tilt-off');
    }

    function tick(now) {
      var dt = last ? now - last : 16.7;
      last = now;

      if (dt > 45) slow += 1;
      else if (slow > 0) slow -= 0.5;
      if (slow > 14) {
        shutDown();
        return;
      }

      var ease = 1 - Math.pow(1 - 0.085, dt / 16.7);
      var any = false;

      states.forEach(function (state, media) {
        var c = state.cur;
        var t = state.target;
        var settled = true;

        Object.keys(NEUTRAL).forEach(function (key) {
          var diff = t[key] - c[key];
          if (Math.abs(diff) > 0.0015) {
            c[key] += diff * ease;
            settled = false;
          } else {
            c[key] = t[key];
          }
        });

        apply(media, c);

        if (settled && !state.active) {
          clear(media);
          states.delete(media);
        } else {
          any = true;
        }
      });

      if (any) {
        window.requestAnimationFrame(tick);
      } else {
        running = false;
        last = 0;
      }
    }

    function kick() {
      if (running || disabled) return;
      running = true;
      window.requestAnimationFrame(tick);
    }

    document.addEventListener('pointermove', function (event) {
      if (disabled || event.pointerType !== 'mouse') return;

      var media = event.target && event.target.closest ? event.target.closest(TILT_TARGETS) : null;

      states.forEach(function (state, el) {
        if (el !== media && state.active) release(state);
      });

      if (!media) {
        kick();
        return;
      }

      var r = media.getBoundingClientRect();
      if (!r.width || !r.height) return;
      var px = (event.clientX - r.left) / r.width - 0.5;
      var py = (event.clientY - r.top) / r.height - 0.5;

      var state = states.get(media);
      if (!state) {
        state = { cur: copy(NEUTRAL), target: copy(NEUTRAL), active: true };
        states.set(media, state);
        media.classList.add('dm-tilting');
      }

      state.active = true;
      // At most ~2 degrees (X) and ~2.5 degrees (Y) at the very edge and a 2% swell:
      // the object gains weight, it never floats or turns.
      state.target = {
        rx: py * -4,
        ry: px * 5,
        gx: (px + 0.5) * 100,
        gy: (py + 0.5) * 100,
        sx: px * -14,
        sy: 22 + py * -8,
        sa: 0.22,
        sc: 1.02,
        tz: 0
      };
      kick();
    }, { passive: true });

    function releaseAll() {
      states.forEach(function (state) { release(state); });
      kick();
    }

    root.addEventListener('mouseleave', releaseAll);
    window.addEventListener('scroll', releaseAll, { passive: true });
  }

  // Phones and tablets: no tilt. Cards swell by at most two percent while they pass
  // through the middle of the screen, a soft sense of depth while you scroll.
  function initTouchDepth() {
    if (reduce || fine || !window.requestAnimationFrame) return;

    var items = new Map();
    var visible = new Set();
    var ticking = false;

    Array.prototype.forEach.call(document.querySelectorAll(TILT_TARGETS), function (media) {
      var img = media.querySelector('.drbali-product-card__image--primary, .drbali-card__image--primary');
      if (img) items.set(media, { media: media, img: img });
    });

    if (!items.size) return;

    function update() {
      ticking = false;
      var vw = window.innerWidth || document.documentElement.clientWidth;
      var vh = window.innerHeight || document.documentElement.clientHeight;

      visible.forEach(function (item) {
        var r = item.media.getBoundingClientRect();
        var dx = (r.left + r.width / 2 - vw / 2) / vw;
        var dy = (r.top + r.height / 2 - vh / 2) / vh;
        var p = Math.max(0, 1 - Math.sqrt(dx * dx + dy * dy) * 1.8);
        item.img.style.scale = (1 + 0.015 * p).toFixed(4);
      });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    var watcher = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var item = items.get(entry.target);
        if (!item) return;
        if (entry.isIntersecting) visible.add(item);
        else visible.delete(item);
      });
      onScroll();
    }, { rootMargin: '10% 10% 10% 10%' });

    items.forEach(function (item, media) { watcher.observe(media); });

    // Capture phase, so horizontal swipes inside product rails are noticed too.
    document.addEventListener('scroll', onScroll, { capture: true, passive: true });
    window.addEventListener('resize', onScroll);
  }

  // Hero: as the page scrolls, the slide stack moves at a fraction of the page
  // speed, so the photograph seems to sit slightly deeper than the page.
  // The photograph itself is never scaled, filtered or recoloured.
  function initHeroParallax() {
    if (reduce || small || !window.requestAnimationFrame) return;
    var hero = document.querySelector('drbali-hero');
    var stack = hero ? hero.querySelector('.drbali-hero__slides') : null;
    if (!stack) return;

    var ticking = false;
    var inView = true;

    function update() {
      ticking = false;
      if (!inView) return;
      var r = hero.getBoundingClientRect();
      var y = Math.max(0, -r.top);
      stack.style.translate = '0 ' + (y * 0.22).toFixed(1) + 'px';
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    new IntersectionObserver(function (entries) {
      inView = entries[0].isIntersecting;
      onScroll();
    }).observe(hero);

    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  // The editorial photo drifts about two percent slower than the page and
  // leans a few pixels toward the pointer. Desktop only.
  function initParallax(main) {
    if (reduce || !fine || !window.requestAnimationFrame) return;

    var lookup = new Map();
    var visible = new Set();
    var ticking = false;

    Array.prototype.forEach.call(main.querySelectorAll('.drbali-editorial__media--primary'), function (frame) {
      var img = frame.querySelector('img');
      if (!img) return;
      img.style.scale = '1.06';
      lookup.set(frame, { frame: frame, img: img, mx: 0 });
    });

    if (!lookup.size) return;

    function update() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      visible.forEach(function (item) {
        var r = item.frame.getBoundingClientRect();
        var p = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
        p = Math.max(-1, Math.min(1, p));
        item.img.style.translate = item.mx.toFixed(1) + 'px ' + (-p * r.height * 0.025).toFixed(1) + 'px';
      });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    var watcher = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var item = lookup.get(entry.target);
        if (!item) return;
        if (entry.isIntersecting) visible.add(item);
        else visible.delete(item);
      });
      onScroll();
    }, { rootMargin: '12% 0px 12% 0px' });

    lookup.forEach(function (item, frame) {
      watcher.observe(frame);

    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  // The band only moves while it is on screen.
  function initMarquee() {
    var bands = document.querySelectorAll('[data-drbali-marquee]');
    if (!bands.length) return;

    var watcher = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle('is-offscreen', !entry.isIntersecting);
      });
    });

    Array.prototype.forEach.call(bands, function (band) { watcher.observe(band); });
  }

  // Add to cart: a quiet confirmation card instead of a silent label change.
  // It never blocks the page and steps aside on its own after a few seconds.
  function initCartToast() {
    var toast = null;
    var hideTimer = null;

    function build() {
      toast = document.createElement('div');
      toast.className = 'dm-cart-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.innerHTML =
        '<div class="dm-cart-toast__media"></div>' +
        '<div class="dm-cart-toast__copy">' +
          '<p class="dm-cart-toast__label">Sepetinize eklendi</p>' +
          '<p class="dm-cart-toast__title"></p>' +
        '</div>' +
        '<button type="button" class="dm-cart-toast__view">Sepeti gör</button>' +
        '<button type="button" class="dm-cart-toast__close" aria-label="Kapat">' +
          '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3.5 3.5l9 9M12.5 3.5l-9 9" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>' +
        '</button>';
      document.body.appendChild(toast);

      toast.querySelector('.dm-cart-toast__close').addEventListener('click', hide);
      toast.querySelector('.dm-cart-toast__view').addEventListener('click', function () {
        hide();
        var trigger = document.querySelector('#cart-icon-bubble');
        if (trigger) trigger.click();
        else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      });
      toast.addEventListener('mouseenter', function () { window.clearTimeout(hideTimer); });
      toast.addEventListener('mouseleave', function () { schedule(); });
    }

    function hide() {
      window.clearTimeout(hideTimer);
      if (toast) toast.classList.remove('is-visible');
    }

    function schedule() {
      window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(hide, 4800);
    }

    document.addEventListener('drbali:cart:silent-updated', function (event) {
      try {
        var res = event.detail && event.detail.response;
        var item = res && res.items && res.items.length ? res.items[0] : res;
        if (!toast) build();

        var title = toast.querySelector('.dm-cart-toast__title');
        title.textContent = item && item.product_title ? item.product_title : '';

        var media = toast.querySelector('.dm-cart-toast__media');
        media.textContent = '';
        if (item && item.image) {
          var img = document.createElement('img');
          img.alt = '';
          img.width = 56;
          img.height = 70;
          img.src = item.image + (item.image.indexOf('?') === -1 ? '?' : '&') + 'width=140';
          media.appendChild(img);
        }

        toast.classList.remove('is-visible');
        void toast.offsetWidth;
        toast.classList.add('is-visible');
        schedule();
      } catch (e) { /* the cart itself already updated; this is only a courtesy */ }
    });
  }

  // ---------------------------------------------------------------------------
  // Hero, editorial controls (01 —— 03 on the left, hairline arrows on the right).
  // Works on top of the theme's own <drbali-hero>; the slides and photographs are
  // never touched. If anything is missing, the original controls stay as they are.
  // ---------------------------------------------------------------------------
  var ARROW_PREV = '<svg viewBox="0 0 32 12" fill="none" aria-hidden="true"><path d="M31 6H1.5M6.5 1 1.5 6l5 5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ARROW_NEXT = '<svg viewBox="0 0 32 12" fill="none" aria-hidden="true"><path d="M1 6h29.5M25.5 1l5 5-5 5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function initHeroEditorial() {
    var hero = document.querySelector('drbali-hero');
    if (!hero || !window.customElements) return;

    window.customElements.whenDefined('drbali-hero').then(function () {
      var controls = hero.querySelector('[data-hero-controls]');
      var progress = controls ? controls.querySelector('.drbali-hero__progress') : null;
      var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-slide]'));
      if (!controls || !progress || slides.length < 2) return;

      function two(n) { return n < 10 ? '0' + n : String(n); }

      var index = document.createElement('div');
      index.className = 'drbali-hero__index';
      index.setAttribute('aria-hidden', 'true');
      var current = document.createElement('span');
      current.className = 'drbali-hero__index-current';
      var total = document.createElement('span');
      total.className = 'drbali-hero__index-total';
      total.textContent = two(slides.length);

      controls.insertBefore(index, progress);
      index.appendChild(current);
      index.appendChild(progress);
      index.appendChild(total);

      var prev = controls.querySelector('[data-hero-prev]');
      var next = controls.querySelector('[data-hero-next]');
      if (prev) prev.innerHTML = ARROW_PREV;
      if (next) next.innerHTML = ARROW_NEXT;

      var pause = controls.querySelector('[data-hero-pause]');
      if (pause) pause.textContent = 'Slayt gösterisini duraklat';

      var shown = -1;
      var swapTimer = null;
      function sync(immediate) {
        var active = 0;
        slides.forEach(function (slide, i) { if (slide.classList.contains('is-active')) active = i; });
        if (active === shown) return;
        shown = active;
        if (immediate || reduce) {
          current.textContent = two(active + 1);
          return;
        }
        current.classList.add('is-changing');
        window.clearTimeout(swapTimer);
        swapTimer = window.setTimeout(function () {
          current.textContent = two(shown + 1);
          current.classList.remove('is-changing');
        }, 380);
      }

      sync(true);
      new MutationObserver(function () { sync(false); }).observe(hero.querySelector('.drbali-hero__slides') || hero, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true
      });

      hero.classList.add('dm-hero-editorial');

      // Calm autoplay: rest while the mouse is over the photograph or the hero is off screen.
      var viewport = hero.querySelector('[data-hero-viewport]');
      if (typeof hero.addPauseReason === 'function' && typeof hero.removePauseReason === 'function') {
        if (viewport && fine) {
          viewport.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hero.addPauseReason('dm-hover'); });
          viewport.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hero.removePauseReason('dm-hover'); });
        }
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting) hero.removePauseReason('dm-offscreen');
            else hero.addPauseReason('dm-offscreen');
          }, { threshold: 0.2 }).observe(hero);
        }
      }
    }).catch(function () {});
  }

  // ---------------------------------------------------------------------------
  // Product page gallery: swipe left / right on the main image (touch only).
  // Uses the gallery's own public method, so variant syncing keeps working.
  // ---------------------------------------------------------------------------
  function initGallerySwipe() {
    var galleries = document.querySelectorAll('drbali-product-gallery');
    if (!galleries.length || !window.customElements) return;

    window.customElements.whenDefined('drbali-product-gallery').then(function () {
      Array.prototype.forEach.call(galleries, function (gallery) {
        var stage = gallery.querySelector('.drbali-product__stage');
        if (!stage || typeof gallery.setActiveMedia !== 'function') return;

        var items = Array.prototype.slice.call(gallery.querySelectorAll('.drbali-product__stage-item[data-media-id]'));
        if (items.length < 2) return;

        stage.style.touchAction = 'pan-y';
        var startX = null;
        var startY = null;
        var swiped = false;

        stage.addEventListener('pointerdown', function (e) {
          if (e.pointerType !== 'touch' && e.pointerType !== 'pen') return;
          startX = e.clientX;
          startY = e.clientY;
          swiped = false;
        }, { passive: true });

        stage.addEventListener('pointerup', function (e) {
          if (startX === null) return;
          var dx = e.clientX - startX;
          var dy = e.clientY - startY;
          startX = null;
          startY = null;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;

          var activeId = String(gallery.activeMediaId);
          var i = 0;
          items.forEach(function (item, n) { if (String(item.dataset.mediaId) === activeId) i = n; });
          var target = items[(i + (dx < 0 ? 1 : -1) + items.length) % items.length];
          swiped = true;
          gallery.setActiveMedia(String(target.dataset.mediaId), true);
        });

        stage.addEventListener('pointercancel', function () {
          startX = null;
          startY = null;
        });

        // A swipe should not also open the full-screen viewer.
        stage.addEventListener('click', function (e) {
          if (!swiped) return;
          swiped = false;
          e.preventDefault();
          e.stopPropagation();
        }, true);
      });
    }).catch(function () {});
  }

  // ---------------------------------------------------------------------------
  // Newsletter pop-up etiquette: never on product or search pages, never sooner
  // than 20 seconds, never on top of the cart, search, filters or menu, and not
  // again during a visit in which something was added to the cart.
  // ---------------------------------------------------------------------------
  function initPopupEtiquette(template) {
    var popup = document.querySelector('drbali-newsletter-popup-v2');
    if (!popup || !window.customElements) return;

    window.customElements.whenDefined('drbali-newsletter-popup-v2').then(function () {
      if (typeof popup.open !== 'function' || typeof popup.cleanupTriggers !== 'function') return;
      var key = (popup.storageKey || 'drbali-newsletter-v2') + ':shopping';
      var hasResult = !!(popup.success || popup.error);
      if (hasResult) return; // a submitted form must always show its result

      function shopping() {
        try { return window.sessionStorage.getItem(key) === '1'; } catch (e) { return false; }
      }

      function busy() {
        var b = document.body;
        if (b.classList.contains('drbali-qv-open') || b.classList.contains('drbali-search-open') || b.classList.contains('drbali-product-lightbox-open')) return true;
        return !!document.querySelector('cart-drawer.active, .drbali-filter.is-open, details[data-drbali-mega][open], [data-mobile-open="true"]');
      }

      var originalOpen = popup.open.bind(popup);
      popup.open = function () {
        if (popup.opened || shopping()) return;
        if (busy()) {
          popup.cleanupTriggers();
          popup.timer = window.setTimeout(function () {
            popup.timer = null;
            popup.open();
          }, 6000);
          return;
        }
        originalOpen();
      };

      if (template === 'product' || template.indexOf('product.') === 0 || template === 'search' || shopping()) {
        popup.cleanupTriggers();
        return;
      }

      if (popup.timer && !popup.opened && typeof popup.schedule === 'function') {
        popup.cleanupTriggers();
        popup.delay = Math.max(Number(popup.delay) || 0, 20000);
        popup.schedule();
      }

      document.addEventListener('drbali:cart:silent-updated', function () {
        try { window.sessionStorage.setItem(key, '1'); } catch (e) { /* private mode */ }
        if (!popup.opened) popup.cleanupTriggers();
      });
    }).catch(function () {});
  }

  // ===========================================================================
  // SIGNATURE 1 — The chapter rail.
  // Desktop only: a small vertical caption in the left margin names the chapter
  // the reader is in (I — Seçki, II — Hikâyemiz ...). It appears once the
  // hero has passed, changes quietly, and makes the page read like a journal.
  // ===========================================================================
  var CHAPTERS = [
    ['.drbali-statement', 'Önsöz'],
    ['.drbali-featured__grid', 'I — Seçki'],
    ['.drbali-editorial__media-wrap', 'II — Hikâyemiz'],
    ['.drbali-layering__stage', 'III — Bakım Katmanı'],
    ['.drbali-shoplook__stage', 'IV — Ritüel'],
    ['.drbali-category-nav__grid', 'V — Bakım Alanları'],
    ['.drbali-science__points', 'VI — Formül'],
    ['.drbali-finder', 'VII — Rehber']
  ];

  function initChapterRail(main) {
    if (!mq('(min-width: 1200px)') || !mq('(hover: hover) and (pointer: fine)')) return;

    var sections = [];
    CHAPTERS.forEach(function (entry) {
      var inner = main.querySelector(entry[0]);
      var section = inner ? inner.closest('.shopify-section') : null;
      if (section) sections.push({ el: section, label: entry[1] });
    });
    if (sections.length < 3) return;

    var rail = document.createElement('div');
    rail.className = 'dm-rail';
    rail.setAttribute('aria-hidden', 'true');
    var text = document.createElement('span');
    text.className = 'dm-rail__text';
    var line = document.createElement('span');
    line.className = 'dm-rail__line';
    rail.appendChild(line);
    rail.appendChild(text);
    document.body.appendChild(rail);

    var current = null;
    var swap = null;
    function show(label) {
      if (label === current) return;
      current = label;
      if (!label) {
        rail.classList.remove('is-visible');
        return;
      }
      if (!rail.classList.contains('is-visible') || reduce) {
        text.textContent = label;
        rail.classList.add('is-visible');
        return;
      }
      text.classList.add('is-changing');
      window.clearTimeout(swap);
      swap = window.setTimeout(function () {
        text.textContent = current;
        text.classList.remove('is-changing');
      }, 320);
    }

    var active = new Map();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var item = sections.filter(function (s) { return s.el === entry.target; })[0];
        if (!item) return;
        if (entry.isIntersecting) active.set(item.el, item);
        else active.delete(item.el);
      });
      var chosen = null;
      sections.forEach(function (s) { if (active.has(s.el)) chosen = s; });
      show(chosen ? chosen.label : null);
    }, { rootMargin: '-48% 0px -48% 0px' });

    sections.forEach(function (s) { io.observe(s.el); });
  }

  // ===========================================================================
  // SIGNATURE 2 — Specimen cards.
  // Every product card carries a quiet index number (N° 01, N° 02 ...),
  // like a numbered specimen in a dermatologist's notebook.
  // ===========================================================================
  function initSpecimens() {
    var groups = new Map();
    Array.prototype.forEach.call(document.querySelectorAll('.drbali-product-card, .drbali-card'), function (card) {
      if (card.querySelector('.dm-no')) return;
      var group = card.closest('.drbali-featured__grid, .drbali-collection__grid, ul, ol, [class*="__grid"]') || card.parentElement;
      var n = (groups.get(group) || 0) + 1;
      groups.set(group, n);

      var host = card.querySelector('.drbali-product-card__info, .drbali-card__content');
      if (!host) return;
      var label = document.createElement('span');
      label.className = 'dm-no';
      label.setAttribute('aria-hidden', 'true');
      label.textContent = 'N° ' + (n < 10 ? '0' + n : n);
      host.insertBefore(label, host.firstChild);
    });
  }

  // ===========================================================================
  // SIGNATURE 3 — The sentence that breathes.
  // The brand statement drifts a few percent sideways as it crosses the screen.
  // It is the only typography on the site that moves.
  // ===========================================================================
  function initBreathingLine(main) {
    if (reduce || !fine || !window.requestAnimationFrame) return;
    var lines = main.querySelectorAll('.drbali-statement__text');
    if (!lines.length) return;

    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      Array.prototype.forEach.call(lines, function (line) {
        var r = line.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var p = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
        p = Math.max(-1, Math.min(1, p));
        line.style.translate = (p * 2.4).toFixed(2) + '% 0';
      });
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  // ===========================================================================
  // SIGNATURE 4 — Continuity between a product card and its page.
  // Browsers with cross-document View Transitions carry the clicked packshot
  // into the product page's main image. Others simply load the page.
  // ===========================================================================
  function initProductContinuity() {
    if (reduce) return;
    document.addEventListener('click', function (event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var link = event.target && event.target.closest ? event.target.closest('a[href*="/products/"]') : null;
      if (!link) return;
      var card = link.closest('.drbali-product-card, .drbali-card');
      if (!card) return;
      var img = card.querySelector('.drbali-product-card__image--primary, .drbali-card__image--primary');
      if (!img) return;
      Array.prototype.forEach.call(document.querySelectorAll('.dm-vt-source'), function (el) {
        el.classList.remove('dm-vt-source');
      });
      img.classList.add('dm-vt-source');
    }, true);

    // Coming back to a page restored from cache: release the name.
    window.addEventListener('pageshow', function () {
      window.setTimeout(function () {
        Array.prototype.forEach.call(document.querySelectorAll('.dm-vt-source'), function (el) {
          el.classList.remove('dm-vt-source');
        });
      }, 700);
    });
  }

  function init() {
    var main = document.getElementById('MainContent');
    if (!main) return;

    try { initCartToast(); } catch (e) { /* courtesy only */ }
    try { initHeroEditorial(); } catch (e) { /* decoration only */ }
    try { initGallerySwipe(); } catch (e) { /* enhancement only */ }
    try { initPopupEtiquette(main.getAttribute('data-template') || ''); } catch (e) { /* etiquette only */ }
    try { initMarquee(); } catch (e) { /* decoration only */ }
    try { initTilt(); } catch (e) { /* decoration only */ }
    try { initTouchDepth(); } catch (e) { /* decoration only */ }
    try { initHeroParallax(); } catch (e) { /* decoration only */ }
    try { initSpecimens(); } catch (e) { /* decoration only */ }
    try { initProductContinuity(); } catch (e) { /* decoration only */ }

    var template = main.getAttribute('data-template') || '';

    try {
      if (template === 'index') {
        Array.prototype.forEach.call(main.querySelectorAll('.drbali-shoplook'), buildLookIndex);
        try { initChapterRail(main); } catch (e) { /* decoration only */ }
        try { initBreathingLine(main); } catch (e) { /* decoration only */ }
        initParallax(main);
        initReveals(main, REVEALS);
      } else if (template.indexOf('collection') === 0) {
        initReveals(main, COLLECTION_REVEALS);
      }
    } catch (error) {
      // If anything goes wrong, show the page exactly as the theme made it.
      root.classList.remove('dm-ready');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
